/* Al Dar Optics — Book Eye Test form controller  (v2 — real delivery feedback)
   - Pre-selects the branch from ?branch= (used by the Stores page "Book" links)
   - Copies the selected branch's email into a hidden field
   - Sends the booking to the Google Apps Script Web App using JSONP, so the
     script's REAL answer is read back. If mail was not sent, the customer sees
     an error instead of a false "Thank you".
   Standalone asset — does not modify theme.js. */
(function () {
  'use strict';

  var form = document.getElementById('BookingForm');
  if (!form) return;

  var branchSel   = form.querySelector('[data-book-branch]');
  var branchEmail = form.querySelector('[data-book-branch-email]');
  var submitBtn   = form.querySelector('[data-book-submit]');
  var okBox       = form.querySelector('[data-book-success]');
  var errBox      = form.querySelector('[data-book-error]');
  var endpoint    = (form.getAttribute('action') || '').trim();

  var FAIL_MSG = 'Sorry — we could not send your booking. Please call or WhatsApp us and we will book you in.';
  var TIMEOUT_MS = 20000;

  function show(box, msg) {
    if (!box) return;
    if (msg != null) box.textContent = msg;
    box.hidden = false;
  }
  function hide(box) { if (box) box.hidden = true; }

  function setBusy(busy, label) {
    if (!submitBtn) return;
    submitBtn.disabled = busy;
    if (label != null) submitBtn.textContent = label;
  }

  // Put the selected branch's email into the hidden field that travels with the form
  function syncBranchEmail() {
    if (!branchSel || !branchEmail) return;
    var opt = branchSel.options[branchSel.selectedIndex];
    branchEmail.value = (opt && opt.getAttribute('data-email')) || '';
  }

  // Pre-select a branch from the URL, e.g. /pages/book-eye-test?branch=Lusail%20Boulevard
  function preselectFromUrl() {
    if (!branchSel || !window.URLSearchParams) return;
    var wanted = (new URLSearchParams(window.location.search).get('branch') || '').trim().toLowerCase();
    if (!wanted) return;
    for (var i = 0; i < branchSel.options.length; i++) {
      if (branchSel.options[i].value.trim().toLowerCase() === wanted) {
        branchSel.selectedIndex = i;
        break;
      }
    }
  }

  preselectFromUrl();
  syncBranchEmail();
  if (branchSel) branchSel.addEventListener('change', syncBranchEmail);

  // ---- JSONP transport: the only cross-origin way to READ an Apps Script reply ----
  function sendJsonp(params, onDone) {
    var cbName = 'aldarBooking_' + Date.now() + '_' + Math.floor(Math.random() * 100000);
    var script = document.createElement('script');
    var finished = false;
    var timer;

    function cleanup() {
      clearTimeout(timer);
      try { delete window[cbName]; } catch (e) { window[cbName] = undefined; }
      if (script.parentNode) script.parentNode.removeChild(script);
    }
    function finish(result) {
      if (finished) return;
      finished = true;
      cleanup();
      onDone(result);
    }

    window[cbName] = function (data) { finish(data || { ok: false, error: 'Empty reply' }); };

    params.set('callback', cbName);
    script.src = endpoint + (endpoint.indexOf('?') > -1 ? '&' : '?') + params.toString();
    script.onerror = function () {
      finish({ ok: false, error: 'Could not reach the booking script (not deployed, or access is not set to "Anyone").' });
    };
    timer = setTimeout(function () {
      finish({ ok: false, error: 'The booking script did not answer in time.' });
    }, TIMEOUT_MS);

    document.head.appendChild(script);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    hide(okBox);
    hide(errBox);

    // Browser validation (required fields, email/date/time formats)
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      return;
    }
    if (!endpoint) {
      show(errBox, FAIL_MSG);
      if (window.console) console.warn('[booking] No Apps Script URL set in the section settings.');
      return;
    }

    syncBranchEmail();

    var params = new URLSearchParams(new FormData(form));
    params.set('page_url', window.location.href);

    var originalLabel = submitBtn ? submitBtn.textContent : '';
    setBusy(true, 'Sending…');

    sendJsonp(params, function (res) {
      setBusy(false, originalLabel);

      if (res && res.ok) {
        show(okBox);
        form.reset();
        preselectFromUrl();
        syncBranchEmail();
        if (okBox && typeof okBox.scrollIntoView === 'function') {
          okBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (window.console && res.to) console.log('[booking] Emailed to:', res.to);
      } else {
        show(errBox, FAIL_MSG);
        if (window.console) console.error('[booking] Failed:', (res && res.error) || 'unknown error');
      }
    });
  });
})();